import { getError } from "@/utils/helpers";
import ImageService from "@/services/ImageService";

export const namespaced = true;

function setImages(commit, response) {
  commit("SET_IMAGES", response.data);
  commit("SET_LOADING", false);
}

export const state = {
  images: [],
  loading: false,
  error: null
};

export const mutations = {
  SET_IMAGES(state, images) {
    state.images = images;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export const actions = {
  getImages({ commit }) {
    commit("SET_LOADING", true);
    ImageService.getImages()
      .then(response => {
        setImages(commit, response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      });
  },
  updateImage(payload) {
    return ImageService.putImage(payload.id, payload);
  }
};

export const getters = {
  images: state => {
    return state.images;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  }
};
